module.exports = __webpack_public_path__ + "static/media/photo-example-bad-corner-driveway.c5cae9e9.jpg";